import apiRequestType from "../../apiRequestType";
import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";

const lockPoll = (data) => {
  return apiRequestType(apiTypes.POST, apiConstants.SOCIAL.LOCK_POLL, data);
};

export default lockPoll;
